import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { createSimpleUser } from '../user/SimpleUser';

/**
 * # Comment
 *
 * Comment을 설명하세요.
 */
export const Comment = types
  .model('Comment')
  // --------------------------------------------------------------------------
  .props({
    commentSid: types.optional(types.number, 0),
    projectSid: types.optional(types.number, 0),
    comment: types.optional(types.string, ''),
    regDt: types.optional(types.number, 0),
    updDt: types.optional(types.number, 0),
    regUser: createSimpleUser(),
    updUser: createSimpleUser(),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model comment --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IComment;
      (Object.keys(newProps) as TCommentKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TComment = Instance<typeof Comment>;
type TCommentSnapshot = SnapshotOut<typeof Comment>;

export interface IComment extends TComment {}
export type TCommentKeys = keyof TCommentSnapshot & string;
export interface ICommentSnapshot extends TCommentSnapshot {}
export const createComment = () => types.optional(Comment, {} as TComment);
